import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1464d8ea&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=1464d8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1464d8ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1464d8ea')) {
      api.createRecord('1464d8ea', component.options)
    } else {
      api.reload('1464d8ea', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=1464d8ea&scoped=true&", function () {
      api.rerender('1464d8ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/samurai/Settings/Index.vue"
export default component.exports